require('./aggregatorTinkStatus.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
import { connect } from 'react-redux';
const { withRouter } = require('react-router-dom');
const { bindActionCreators } = require('redux');
const classNames = require('classnames');

// @components
const { OKButton } = require('components/commons/OKButton/OKButton');
const {
  AggregatorSecondKeyAuthModal,
} = require('components/aggregator/aggregatorSecondKeyAuthModal/aggregatorSecondKeyAuthModal');
import { ConfirmModal } from 'components/commons/confirmModal/confirmModal';

// @actions
import { removeEntity, getConsentUpdateTinkLinkUrl } from 'actions/aggregator/aggregatorData';

// @utilities
import Storage from 'utilities/storage';
const { FormattedText, formatText } = require('core/i18n').i18n;
import {
  recordLink,
  PROC_AGGREGATOR,
  PROC_OTP_MODAL_REQUEST_OTP,
  TINK_PG_PAGE_NAME,
  TINK_PG_CONNECTION_ERROR_PRIMARY_ACTION,
  TINK_PG_DELETE_BANK_TAG,
  TINK_PG_NEW_KEY_TAG,
  TINK_PG_NEW_KEY_INPUT_ACTION,
  TINK_PG_NEW_KEY_INPUT_TAG,
  PROC_INSERT_OTP,
  PROC_NOT_RECEIVED_OTP,
  PROC_EXPIRED_OTP_REQUEST_OTP,
  PROC_EXPIRED_OTP_REMOVE_ENTITY,
  PROC_ERROR_CONNECTION_REQUEST_OTP,
  PROC_ERROR_CONNECTION_REMOVE_ENTITY,
} from 'utilities/tagging';
const { scrollToTop } = require('commonsUtilities/scrollUtils');

// @constants
import { STEP } from 'constants/aggregator/consentViewType';
import { SELECTED_BANK } from 'constants/aggregator/localStorageKeys';
import {
  AUTHENTICATION_ERROR,
  SESSION_EXPIRED,
  UPDATED,
  AWAITING_MOBILE_BANKID_AUTHENTICATION,
  AWAITING_THIRD_PARTY_APP_AUTHENTICATION,
  DELETED,
  AWAITING_SUPPLEMENTAL_INFORMATION,
  MESSAGES_STATUSES as MESSAGES_STATUSES_TINK,
} from 'constants/aggregator/tinkStatuses.constants';
import {
  SECOND_FACTOR_AUTHENTICATION,
  BAD_SECOND_FACTOR_AUTHENTICATION,
  EXPIRED_SECOND_FACTOR_AUTHENTICATION,
  OK,
  REVIEW,
  BAD_CREDENTIALS,
  PSD2_SESSION_EXPIRED,
  PSD2_CONSENT_INVALID,
  PENDING_SCRAPING_CREDENTIALS,
  MESSAGES_STATUSES as MESSAGES_STATUSES_EUROBITS,
} from 'constants/aggregator/statuses';
import { RENEW_TOKEN, RENEW_CONSENT } from 'constants/aggregator/psd2DecoupledFlowType';
import { PSD2_FLOW_TYPE } from 'constants/aggregator/localStorageKeys';

const SECOND_KEY_STATUSES = [
  // Tink
  AWAITING_SUPPLEMENTAL_INFORMATION,
  AUTHENTICATION_ERROR,
  AWAITING_MOBILE_BANKID_AUTHENTICATION,
  AWAITING_THIRD_PARTY_APP_AUTHENTICATION,
  SESSION_EXPIRED,
  // Eurobits
  SECOND_FACTOR_AUTHENTICATION,
  BAD_SECOND_FACTOR_AUTHENTICATION,
  EXPIRED_SECOND_FACTOR_AUTHENTICATION,
  BAD_CREDENTIALS,
  SECOND_FACTOR_AUTHENTICATION,
];
const TRANSLATION_KEY_PREFIX = 'aggregatorManageEntities';

const getMsgStatusesList = () => {
  let messagesList = [...MESSAGES_STATUSES_TINK];
  MESSAGES_STATUSES_EUROBITS.map(mssgEur => {
    return (
      !MESSAGES_STATUSES_TINK.find(mssgTink => mssgTink.NAME === mssgEur.NAME) &&
      messagesList.push(mssgEur)
    );
  });
  return messagesList;
};
const MESSAGES_STATUSES = getMsgStatusesList();

class AggregatorTinkStatusClass extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpenKeyModal: false,
      isOpenRemoveModal: false,
    };
  }

  getPrimaryButtonAction = statusContent => {
    const {
      userBankId,
      bankCode,
      bankStatus,
      bankName,
      bankLogo,
      history,
      bankTinkCredentials,
      getConsentUpdateTinkLinkUrl,
    } = this.props;

    switch (bankStatus) {
      // Tink
      case AUTHENTICATION_ERROR:
        recordLink(TINK_PG_PAGE_NAME, TINK_PG_CONNECTION_ERROR_PRIMARY_ACTION, TINK_PG_NEW_KEY_TAG);
        getConsentUpdateTinkLinkUrl(userBankId, bankTinkCredentials);
        sessionStorage.setItem('userBankId', JSON.stringify(userBankId));
        break;

      case AWAITING_SUPPLEMENTAL_INFORMATION:
        recordLink(TINK_PG_PAGE_NAME, TINK_PG_CONNECTION_ERROR_PRIMARY_ACTION, TINK_PG_NEW_KEY_TAG);
        getConsentUpdateTinkLinkUrl(userBankId, bankTinkCredentials);
        sessionStorage.setItem('userBankId', JSON.stringify(userBankId));
        break;

      case SESSION_EXPIRED: // EUROBITS -> EXPIRED_SECOND_FACTOR_AUTHENTICATION
        recordLink(TINK_PG_PAGE_NAME, TINK_PG_NEW_KEY_INPUT_ACTION, TINK_PG_NEW_KEY_INPUT_TAG);
        getConsentUpdateTinkLinkUrl(userBankId, bankTinkCredentials);
        sessionStorage.setItem('userBankId', JSON.stringify(userBankId));
        break;

      // Eurobits
      case SECOND_FACTOR_AUTHENTICATION:
        recordLink(PROC_AGGREGATOR, PROC_INSERT_OTP);
        history.push(`${statusContent.URL}${userBankId}`);
        scrollToTop();
        break;

      case BAD_SECOND_FACTOR_AUTHENTICATION:
        recordLink(PROC_AGGREGATOR, PROC_ERROR_CONNECTION_REQUEST_OTP);
        this.handleShowKeyModal();
        break;

      case EXPIRED_SECOND_FACTOR_AUTHENTICATION:
        recordLink(PROC_AGGREGATOR, PROC_EXPIRED_OTP_REQUEST_OTP);
        this.handleShowKeyModal();
        break;

      case BAD_CREDENTIALS:
        history.push(`${statusContent.URL}${userBankId}`);
        scrollToTop();
        break;

      case PSD2_SESSION_EXPIRED:
        Storage.localStorage.set(PSD2_FLOW_TYPE, RENEW_TOKEN);
        history.push(`${statusContent.URL}${bankCode}`);
        scrollToTop();
        break;

      case PSD2_CONSENT_INVALID:
        Storage.localStorage.set(SELECTED_BANK, {
          bankName: bankName,
          bankLogo: bankLogo,
          userBankId,
        });
        Storage.localStorage.set(PSD2_FLOW_TYPE, RENEW_CONSENT);
        history.push(`/myprofile/global/entities/consent/${STEP}`);
        scrollToTop();
        break;

      case PENDING_SCRAPING_CREDENTIALS:
        history.push(`${statusContent.URL}${userBankId}`);
        scrollToTop();
        break;
    }
  };

  getSecondaryButtonAction = () => {
    const { bankStatus, history } = this.props;

    switch (bankStatus) {
      // Tink
      case (AWAITING_SUPPLEMENTAL_INFORMATION,
      AUTHENTICATION_ERROR,
      AWAITING_MOBILE_BANKID_AUTHENTICATION,
      AWAITING_THIRD_PARTY_APP_AUTHENTICATION):
        recordLink(
          TINK_PG_PAGE_NAME,
          TINK_PG_CONNECTION_ERROR_PRIMARY_ACTION,
          TINK_PG_DELETE_BANK_TAG
        );
        //this.handleShowKeyModal();
        history.push('/myprofile/global/entities/manage');
        scrollToTop();
        break;
      case SESSION_EXPIRED:
        recordLink(TINK_PG_PAGE_NAME, TINK_PG_NEW_KEY_INPUT_ACTION, TINK_PG_DELETE_BANK_TAG);
        history.push('/myprofile/global/entities/manage');
        scrollToTop();
        break;

      // Eurobits
      case SECOND_FACTOR_AUTHENTICATION:
        recordLink(PROC_AGGREGATOR, PROC_NOT_RECEIVED_OTP);
        this.handleShowKeyModal();
        history.push('/myprofile/global/entities/manage');
        scrollToTop();
        break;

      case BAD_SECOND_FACTOR_AUTHENTICATION:
        recordLink(PROC_AGGREGATOR, PROC_ERROR_CONNECTION_REMOVE_ENTITY);
        this.showRemoveEntityModal(true);
        history.push('/myprofile/global/entities/manage');
        scrollToTop();
        break;

      case EXPIRED_SECOND_FACTOR_AUTHENTICATION:
        recordLink(PROC_AGGREGATOR, PROC_EXPIRED_OTP_REMOVE_ENTITY);
        this.showRemoveEntityModal(true);
        history.push('/myprofile/global/entities/manage');
        scrollToTop();
    }
  };

  showRemoveEntityModal = isOpen => {
    this.setState({ isOpenRemoveModal: isOpen });
  };

  requestSendingNewOtp = () => {
    const { getSecondFactorAuth, userBankId } = this.props;

    recordLink(PROC_AGGREGATOR, PROC_OTP_MODAL_REQUEST_OTP);
    getSecondFactorAuth(userBankId);
  };

  handleShowKeyModal = () => {
    this.setState({ isOpenKeyModal: true });
  };

  handleHideKeyModal = () => {
    this.setState({ isOpenKeyModal: false });
  };

  handleOnAcceptRemoveEntity = () => {
    const { removeEntity, userBankId } = this.props;

    removeEntity(userBankId);
    this.showRemoveEntityModal(false);
  };

  handleOnCancelRemoveEntity = () => {
    this.showRemoveEntityModal(false);
  };

  buildContent = () => {
    const { isOpenKeyModal, isOpenRemoveModal } = this.state;
    const {
      bankName,
      userBankId,
      bankStatus,
      settingsVariant,
      isLeftAlign,
      hasErrorsAndNoProducts,
    } = this.props;
    const descriptionInjectedStrings = bankStatus === REVIEW ? [bankName, bankName] : [bankName];
    const statusContent = MESSAGES_STATUSES.filter(content => content.NAME === bankStatus)[0] || {};

    const getClassName = (className) => {
      let rootClass;
      if (!className) {
        rootClass = !hasErrorsAndNoProducts
          ? 'aggregator-tink-status'
          : 'aggregator-tink-settings-status-warning';
      } else {
        rootClass = !hasErrorsAndNoProducts
          ? `aggregator-tink-status${className}`
          : `aggregator-tink-settings-status-warning${className}`;
      }

      return !hasErrorsAndNoProducts
        ? classNames(rootClass, {
            settingsVariant,
            isLeftAlign,
          })
        : rootClass;
    };

    if ((bankStatus !== UPDATED || bankStatus !== OK) && bankStatus !== DELETED) {
      return (
        <React.Fragment>
          {hasErrorsAndNoProducts && <div className={getClassName('__warning-separator')} />}
          {
            <div className={getClassName()}>
              {statusContent.ICON && (
                <div className={getClassName('__icon')}>
                  <img src={statusContent.ICON} />
                </div>
              )}
              <div className={getClassName('__info-container')}>
                <h3 className={getClassName('__title')}>
                  <FormattedText value={statusContent.TITLE} injectedStrings={[bankName]} />
                </h3>
                <p className={getClassName('__sub-title')}>
                  <FormattedText
                    value={statusContent.DESCRIPTION}
                    injectedStrings={descriptionInjectedStrings}
                  />
                </p>
                {statusContent.INFO && (
                  <p className={getClassName('__info')}>
                    <FormattedText
                      value={statusContent.INFO}
                      injectedStrings={descriptionInjectedStrings}
                    />
                  </p>
                )}
                <div className={getClassName('__button-container')}>
                  {userBankId && statusContent.TEXT_PRIMARY_BUTTON && (
                    <div className={getClassName('__button-container__primary')}>
                      <OKButton
                        modifier={!hasErrorsAndNoProducts ? 'secondary' : 'ghost'}
                        onClick={() => this.getPrimaryButtonAction(statusContent)}
                      >
                        <FormattedText value={statusContent.TEXT_PRIMARY_BUTTON} />
                      </OKButton>
                    </div>
                  )}
                  {SECOND_KEY_STATUSES.includes(bankStatus) && statusContent.TEXT_SECOND_BUTTON && (
                    <div className={getClassName('__button-container__secondary')}>
                      <OKButton
                        onClick={() => this.getSecondaryButtonAction()}
                        modifier="link-ghost"
                      >
                        <FormattedText value={statusContent.TEXT_SECOND_BUTTON} />
                      </OKButton>
                    </div>
                  )}
                </div>
              </div>
            </div>
          }
          <AggregatorSecondKeyAuthModal
            showKeyModal={isOpenKeyModal}
            requestSendingNewOtp={this.requestSendingNewOtp}
            onCloseCallback={this.handleHideKeyModal}
          />
          <ConfirmModal
            open={isOpenRemoveModal}
            title={formatText(`${TRANSLATION_KEY_PREFIX}-modalTitle`)}
            text={formatText(`${TRANSLATION_KEY_PREFIX}-modalText`)}
            onAccept={this.handleOnAcceptRemoveEntity}
            onCancel={this.handleOnCancelRemoveEntity}
          />
        </React.Fragment>
      );
    } else {
      return null;
    }
  };

  render() {
    return this.buildContent();
  }
}

AggregatorTinkStatusClass.propTypes = {
  bankName: PropTypes.string,
  bankCode: PropTypes.string,
  bankLogo: PropTypes.string,
  getSecondFactorAuth: PropTypes.func,
  userBankId: PropTypes.string,
  bankStatus: PropTypes.string,
  removeEntity: PropTypes.func,
  getConsentUpdateTinkLinkUrl: PropTypes.func,
  settingsVariant: PropTypes.bool,
  history: PropTypes.object.isRequired,
  isLeftAlign: PropTypes.bool,
  hasErrorsAndNoProducts: PropTypes.bool,
  bankTinkCredentials: PropTypes.string,
};

const AggregatorTinkStatus = connect(
  () => {},
  dispatch => ({
    removeEntity,
    getConsentUpdateTinkLinkUrl: bindActionCreators(getConsentUpdateTinkLinkUrl, dispatch),
  })
)(withRouter(AggregatorTinkStatusClass));

module.exports.constructor = AggregatorTinkStatus;
module.exports.AggregatorTinkStatus = AggregatorTinkStatus;
